import React, { useEffect, useRef, useState } from "react";
import dateFormat from "dateformat";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

import "./styles/main.css";
import EmojiTray from "./components/EmojiTray";
import ChatInput from "./components/ChatInput";
import Header from "./components/Header";
import ChatSidebar from "./components/ChatSidebar";
import Icon from "../../components/Icon";
import Search from "./components/Search";
import Profile from "./components/Profile";
import Convo from "./components/Convo";
import { useUsersContext } from "../../context/usersContext";
import Home from "../Home";
import Templates from "../../templates";
import requestApi from "../../../../services/requestApi.service";
import cx from "classnames";
import {
	confirmBoxWithImage,
	convertDateToUtc, extractDisplayMessage, getErrorMsg, getOpenChatCount, getProfileFields, getSessionValue,
	handleErrorResponse,
	loadContactsData, loadCustomFormData, parseJSON,
	//resetUnreadCount,
	setSessionValue,
	showToast, updateWpConnectionError
} from "../../../../Common/Appcommon";
import AnalyticsPreview from "../../../Analytics/AnalyticsPreview";

const Chat = ({ match, history }) => {
	const { users, setUserAsUnread, loadUsers, setCurrentContactUser,msgUserId} = useUsersContext();
	const userId = match.params.id;
	let user = Object.keys(users).length > 0 ? users.filter((user) => Number(user.cid) === Number(userId))[0] : undefined;
	const lastMsgRef = useRef(null);
	const scrollDownRef = useRef(null);
	const replyRef = useRef([]);
	const [showAttach, setShowAttach] = useState(false);
	const [showEmojis, setShowEmojis] = useState(false);
	const [showProfileSidebar, setShowProfileSidebar] = useState(false);
	const [showSearchSidebar, setShowSearchSidebar] = useState(false);
	const [newMessage, setNewMessage] = useState("");
	const [showTemplateModal, setTemplateModal] = useState(false);
	const [messages, setMessages] = useState([]);
	const [disableMsgSend, setDisableMsgSend] = useState(false);
	const [remainingTime, setRemainingTime] = useState('0m');
	const [remainingPercentage, setRemainingPercentage] = useState(0);
	const [quickReplyTemplates, setQuickReplyTemplates] = useState([]);
	const [profileFields, setProfileFields] = useState([]);
    const [rerender, setViewRerender] = useState(false);

	const campaignformname = process.env.REACT_APP_CAMPAIGN_FORMNAME;
	const quickreplyformname = process.env.REACT_APP_QUICKREPLY_FORMNAME;
	const campaignlink = `${campaignformname}_0_${campaignformname}_id`;
	const contactformname = process.env.REACT_APP_CONTACT_FORMNAME;

	const prevUser = usePrevious(user);

	useEffect(() => {
		if (!user || user === undefined) {
			if(user === undefined){
				(async ()=>{
					let filterOptions = [];
					filterOptions.push({name: "leadSearch", value: userId});
					let response = await loadContactsData(filterOptions);
					if (response.issuccess) {
						let contacts = response.data;
						loadUsers(contacts);
						getOpenChatCount(contacts);
						user = contacts.filter((user) => Number(user.cid) === Number(userId))[0];
						await loadUserConversations();
					}
				})();
			} else {
				history.push("/");
			}
		} else {
			(async ()=>{
				await loadUserConversations();
			})();
		}
		setSessionValue('isRefreshContacts', false);
	}, []);

	async function loadUserConversations(){
		// let conversations = await getUserConversations();
		// setMessages(conversations);
		scrollToLastMsg();
		setUserAsUnread(user.cid);
		//await getQuickReplyTemplates();
		//if(user.wsapp_unread_count !== 0 && user.wsapp_unread_count !== '0'){
			//await resetUnreadCount(userId);
		//}
		let profileFields = await getProfileFields();

		if(profileFields !== undefined && profileFields !== "" && profileFields !== null){
			setProfileFields(profileFields);
		}
	}

	/*useEffect(() => {
		setNewMessage("");
		user && scrollToLastMsg();
	}, [users]);*/

	useEffect(() => {
		loadConversationData();
	}, [/*users,*/user]);

	function loadConversationData(){
		(async ()=>{
			let loadConverstion = true;

			if(parseJSON(getSessionValue('isRefreshContacts')) && msgUserId !== userId){
				loadConverstion = false;
			}

			//setCurrentContactUser(userId);
			setSessionValue('inboxUserID', userId);

			if(loadConverstion){
				let conversations = await getUserConversations();
				setMessages(conversations);
			}
			if(!prevUser || (prevUser && user && prevUser[`${contactformname}_id`] !== user[`${contactformname}_id`])){
				setNewMessage("");
				setTimeout(() => {
					scrollToLastMsg()},900
				);
			}
			//if(user.wsapp_unread_count !== undefined && user.wsapp_unread_count !== null && user.wsapp_unread_count !== 0 && user.wsapp_unread_count !== '0' && userId !== ''){
				//setUserAsUnread(userId);
				//await resetUnreadCount(userId);
			//}
		})();
	}

	function usePrevious(value) {
		const ref = useRef();
		useEffect(() => {
			ref.current = value;
		});
		return ref.current;
	}

	const openSidebar = (cb) => {
		// close any open sidebar first
		setShowProfileSidebar(false);
		setShowSearchSidebar(false);

		// call callback fn
		cb(true);
	};

	const scrollToLastMsg = () => {
		if(scrollDownRef != null && scrollDownRef.current != null){
			scrollDownRef.current.scrollIntoView({ behavior: "smooth" });
		}
	};

	const submitNewMessage = async () => {

		let newSendMessage = newMessage !== undefined ? newMessage.replace(/\s+/g,'') : '';
		if(newMessage !== undefined && newSendMessage.length > 0){
			newSendMessage = newMessage.trim();
		}else{
			return;
		}

		let msgInfo = {
			0: {
				type : 'text',
				body : newSendMessage
			}
		}

		//Clear chat input.
		setNewMessage("");
		//Temporay message for user. Just for usability
		const newMsgObject = {
			content: wrapMessage(newMessage),
			sender: null,
			time: dateFormat(new Date(),'h:MM TT'),
			status: "sent",
			senderInfo : {
				type : 'User',
				name :''
			}
		};

		let msgCopy = {...messages};
		if(msgCopy['TODAY'] === undefined){
			msgCopy['TODAY'] = [];
		}
		msgCopy.TODAY.push(newMsgObject);
		setMessages(msgCopy);
		scrollToLastMsg();

		let params = {
			"ENTITY": "WHATSAPPPROCESS",
			"OPERATION": "SEND_WHATSAPP_MSG",
			"MSGINFO" : msgInfo,
			"CONTACTID" : userId,
			"isOtherApiReq" : true,
		}
		let response = await requestApi.processServerRequest(params,'WebV2','post');
		if(response.issuccess){
			let data = response.data;
			if(data.status === 'success'){
				//addNewMessage(user.id, newMessage);
			}else{
				if(data['showmsg']  !== undefined && data['showmsg'] === true){
					showToast(data['message'],'top-right','error');
				}else{
					showToast('Failed to send message','top-right','error')
				}

				//update API Error in session to show notification to user.
				if(data['wpApiError'] !== undefined && data['wpApiError'] === true){
					updateWpConnectionError('true');
				}
			}
		}else{
			handleErrorResponse(response.errormsg);
		}
		//await refreshChat();
		scrollToLastMsg();
	};

	const refreshChat = async (srollToLast=false) => {
		let response = await loadContactsData(parseJSON(getSessionValue('filterOption')));
		if(response.issuccess) {
			let contacts = response.data;
			loadUsers(contacts);
			getOpenChatCount(contacts);
			if(srollToLast){
				setTimeout(() => {
					scrollToLastMsg()},900
				);
			}
		} else if (response.errormsg !== ""){
			showToast(response.errormsg, "top-right","error");
		}
	}

	const wrapMessage = (message) => {
		return (<div className={`content-portion`}>{message}</div>);
	}

	const submitNewMediaMessage = async (data) => {

		let params = {
			"ENTITY": "WHATSAPPPROCESS",
			"OPERATION": "SEND_WHATSAPP_MSG",
			"MSGINFO" : data,
			"CONTACTID" : userId,
			"isOtherApiReq" : true,
		}
		let response = await requestApi.processServerRequest(params,'WebV2','post');
		if(response.issuccess){
			let data = response.data;
			if(data.status === 'success'){
				//await refreshChat();
				showToast('Message sent successfully!');
			}else{
				if(data['showmsg']  !== undefined && data['showmsg'] === true){
					showToast(data['message'],'top-right','error');
				}else{
					showToast('Failed to send attachment(s)','top-right','error');
				}

				//update API Error in session to show notification to user.
				if(data['wpApiError'] !== undefined && data['wpApiError'] === true){
					updateWpConnectionError('true');
				}
			}
		}else{
			handleErrorResponse(response.errormsg);
		}
	};

	const getUserConversations = async () => {

		let conversations = [];

		let params = {
			"ENTITY": "WHATSAPPPROCESS",
			"OPERATION": "GET_LEAD_CONVERSATIONS",
			"CONTACTID" : userId,
			"isOtherApiReq" : true,
		}
		setCurrentContactUser(userId);
		let response = await requestApi.processServerRequest(params);
		if(response.issuccess){
			let formData = response.data;
			if(Object.keys(formData).length > 0){
				conversations = await constructMessagesFromData(formData);
			} else {
				setDisableMsgSend(true);
			}
		}else{
			handleErrorResponse(response.errormsg);
		}

		return conversations;
	}

	const constructMessagesFromData = async (data) => {
		let messages = {};

		let today = dateFormat(new Date(),'dd/mm/yyyy');
		let yesterdayDate = new Date(Date.now() - 86400000);
		let yesterday = dateFormat(yesterdayDate,'dd/mm/yyyy');
		let enableMsgSending = false;
		let msgIdIndex = [];
		let uploadableMedia = ['image','audio','video','document'];
		let lastUserInteraction = undefined;
		let timeString = '0m';
		let percentageDifference=0;

		for(let key in data){
			let message = {};
			msgIdIndex[data[key]['Message_ID']] = key;

			let date = dateFormat(convertDateToUtc(data[key]['createdon']),'dd/mm/yyyy');

			//Enable message sending if user interaction less than 24 hours
			if(data[key]['Type'] === 'In' && convertDateToUtc(data[key]['createdon']) > yesterdayDate){
				enableMsgSending = true;
				lastUserInteraction = convertDateToUtc(data[key]['createdon']);
			}

			if(date === today){
				date = 'TODAY';
			}else if(date === yesterday){
				date = 'YESTERDAY';
			}

			if(messages[date] === undefined){
				messages[date] = [];
			}

			let status = data[key]['Status'];
			let content = '';
			let replyToId = data[key]['Reply_To_ID'];
			let errorMsg = '';
			let isProcessed = true;
			let type = data[key]['Type'];
			let contentType = data[key]['Category'];
			let mediaUrl = data[key]['Media_URL'];
			let convoId = +data[key]['table_61_id'];
			let campaignId = data[key]['table_64_0_table_64_id'];

			if(status === 'failed' || status === "undeliverable"){
				errorMsg = getErrorMsg(data[key]['Reason'], !campaignId);
			}

			//Media is still in aws s3 uploading proces.
			if(status !== 'failed' && type === 'In' && uploadableMedia.includes(contentType) && (mediaUrl === '' || mediaUrl === null )){
				isProcessed = false;
			}

			//Skip media from chat if media upload not completed yet.
			if(!isProcessed){
				continue;
			}

			let messageContent = extractDisplayMessage(data[key]['Type'],data[key]['Components'],data[key]['Message_Info'],true);
			let {format, bodyText} = messageContent;
			let msgContentType = messageContent.type;
			content = <AnalyticsPreview formIndex={key} msgContentType={msgContentType} formData={data} source={`inbox`} temptype={data[key]['Template_Name']}/>;
			message = {
				content : content,
				sender: type === 'In',
				time: '',
				status: status,
				id : data[key]['Message_ID'],
				error: errorMsg,
				senderInfo : {},
				headerFormat : format,
				isBodyText : bodyText,
				type : msgContentType,
				convoId : convoId
			}
			//process sender details.
			if(type === 'Out'){
				let tempName = data[key]['Template_Name'] !== undefined && data[key]['Template_Name'] !== null && data[key]['Template_Name'] !== '' ? data[key]['Template_Name'] : '';
				if(data[key][campaignlink] !== undefined && data[key][campaignlink] !== null && data[key][campaignlink] !== ''){
					message['senderInfo'] = {
						type : data[key]['c_Type'],
						name : data[key]['c_Name']
					}

				}else if((tempName !== '') && (tempName === 'Delayed' || tempName === 'Welcome' || tempName === 'Out_Of_Office' || tempName === 'Bot' || tempName === 'Opt Management' || tempName === 'interactive')){
						message['senderInfo'] = {
							type : 'Bot',
							name : tempName !== 'Bot' ? tempName : 'Chatbot'
						}
				}else if(tempName !== '' && tempName === 'Trigger'){
						message['senderInfo'] = {
							type : 'Trigger',
							name : data[key]['nt_name']
						}
				}else{
					message['senderInfo'] = {
						type : 'User',
						name : data[key]['u_Name'] !== '' ? data[key]['u_Name'] : ''
					}
				}
			}else{
				message["updated_username"] = data[key]['updated_username'];
			}

			if(data[key]['createdon'] !== undefined && data[key]['createdon'] !== "" && data[key]['createdon'] != null){
				message['time'] = dateFormat(convertDateToUtc(data[key]['createdon']),'h:MM TT');
			}

			if(replyToId !== '' && replyToId !== null){
				if(msgIdIndex[replyToId] !== undefined && msgIdIndex[replyToId] !== '' && msgIdIndex[replyToId] !== null){
					let replyMsgIndex = msgIdIndex[replyToId];
					message['replycontent'] = extractDisplayMessage(data[replyMsgIndex]['Type'],data[replyMsgIndex]['Components'],data[replyMsgIndex]['Message_Info'],true);
					message['replyid'] = replyToId;
				}
			}

			messages[date].push(message);
		}

		if(lastUserInteraction !== undefined){
			// Calculate the time difference in milliseconds
			const timeDifference = Math.abs(lastUserInteraction.getTime() - yesterdayDate.getTime());

			// Calculate the percentage difference
			percentageDifference = (timeDifference / (1000 * 60 * 60 * 24)) * 100;

			// Calculate the number of hours
			const hours = Math.floor(timeDifference / (1000 * 60 * 60));

			// Calculate the number of minuteshours
			const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);

			if (hours > 0) {
				timeString = `${hours}h`;
			} else {
				timeString = `${minutes}m`;
			}
		}

		setRemainingPercentage(percentageDifference);
		setRemainingTime(timeString);
		setDisableMsgSend(!enableMsgSending);

		return messages;
	}

	const getQuickReplyTemplates = async () => {

		let templates = [];

		const { rowData } = await loadCustomFormData(
			false,
			quickreplyformname,
			{customCondition : 'Type#quick-reply'}
		);

		for(let i = 0; i < rowData.length ; i++){
			templates[i] = rowData[i]
		}

		setQuickReplyTemplates(templates);
	}

	const onChangeLeadUsage = async (userid) => {
		let isBlocked = 'No';
		if(user.wsapp_blocked === 'No'){
			isBlocked = 'Yes';
		}
		let params = {
			"ENTITY": "WHATSAPPPROCESS",
			"OPERATION": "UPDATE_LEADBLOCKED_INFO",
			"FORMID" : userid,
			"status"  : isBlocked,
			"isOtherApiReq" : true,
			"predefinedCondition" : ""
		}
		let res =  await requestApi.processServerRequest(params);
		if(res.issuccess){
			if(isBlocked === 'Yes'){
				user.wsapp_blocked = 'Yes';
				setDisableMsgSend(true);
			}else{
				user.wsapp_blocked = 'No';
				getUserConversations();
				//setDisableMsgSend(false);
			}
			setViewRerender(!rerender);
		}else{
            handleErrorResponse(res.errormsg);
        }

		return user.wsapp_blocked;
	}

	const toggleModal = () => {
		setTemplateModal(!showTemplateModal);
	}

	const openChatList = () => {
		history.push("/inbox");
	}

	const deleteConversation = async (convoId) => {
		let isConfirmed = await confirmBoxWithImage("Delete", "Do you want to delete the message?", "");
		if(!isConfirmed) return;
		let params = {
			"ENTITY": "WHATSAPPPROCESS",
			"OPERATION": "MESSAGE_DELETE",
			"formid"  : convoId,
		}
		let response = await requestApi.processServerRequest(params);
		if(response.issuccess){
			loadConversationData();
		}
	}

	let customSelectOptions = {
		name : "delete_message",
		customClass : "",
		handleOnChange : deleteConversation,
		faIcon : faAngleDown,
		options : [
			{"label" : "Delete", "value" : "delete"},
		],
	}

	return user  ?(
		<div className="chat">
			<div className="chat__body">
				<div className="chat__bg"></div>
				<Header
					refreshChat={refreshChat}
					user={user}
					profileSidebarStatus = {showProfileSidebar}
					openProfileSidebar={() => openSidebar(setShowProfileSidebar)}
					openSearchSidebar={() => openSidebar(setShowSearchSidebar)}
					remainingTime={remainingTime}
					openChatList={openChatList}
					remainingPercentage={remainingPercentage}

				/>
				<div className="chat__content">
				{/*user.messages*/messages && (
					<Convo
						lastMsgRef={lastMsgRef}
						messages={/*user.messages*/messages}
						replyRef={replyRef}
						customSelectOptions={customSelectOptions}
					/>
				)}
					<div className={'scroll-content'} ref={scrollDownRef}/>

				</div>

				<footer className="chat__footer">

						<EmojiTray
							className={`wp-emoji-tray`}
							showEmojis={showEmojis}
							setShowEmojis={setShowEmojis}
							newMessage={newMessage}
							setNewMessage={setNewMessage}
						/>

					<div className={`footer-content`}>
						<button
							className={cx(disableMsgSend ? 'chat_disable_scroll-btn' : "chat_enable_scroll-btn")}
							aria-label="scroll down"
							onClick={scrollToLastMsg}
						>
							<Icon id="downArrow" />
						</button>

						<ChatInput
							showEmojis={showEmojis}
							setShowEmojis={setShowEmojis}
							showAttach={showAttach}
							setShowAttach={setShowAttach}
							newMessage={newMessage}
							setNewMessage={setNewMessage}
							submitNewMessage={submitNewMessage}
							submitNewMediaMessage={submitNewMediaMessage}
							showTemplateModal={toggleModal}
							disableMsgSend={disableMsgSend}
							onChangeLeadUsage={onChangeLeadUsage}
							quickreplyformname={quickreplyformname}
							//onSearchQuickReply={getQuickReplyTemplates}
							user={user}
						/>
					</div>
				</footer>
			</div>
			<ChatSidebar
				heading="Search Messages"
				active={showSearchSidebar}
				closeSidebar={() => setShowSearchSidebar(false)}
			>
				<Search />
			</ChatSidebar>

			<ChatSidebar
				heading="Contact Info"
				active={showProfileSidebar}
				closeSidebar={() => setShowProfileSidebar(false)}
				user={user}
				onChangeLeadUsage={onChangeLeadUsage}
			>
			<Profile rerender={rerender} user={user} profileFields={profileFields} onChangeLeadUsage={onChangeLeadUsage}/>
			</ChatSidebar>

			<Templates
				isOpen={showTemplateModal}
				toggleModal={toggleModal}
				user={user}
				refreshChat={()=>refreshChat(true)}
			/>
		</div>
	):(<Home/>);
};

export default Chat;
